import React from "react";

const TooltipWithReadMore = ({ content, onReadMoreClick }) => {
    return (
        <div className="relative group w-full text-left mb-2">
            <span className="text-gray-700 mb-4 leading-relaxed sm:leading-snug max-w-full sm:max-w-[90%] md:max-w-[95%]">
                {content.slice(0, 150)}
            </span>
            {content.length > 150 && (
                <>
                    <span className="text-sm">...</span>
                    <span 
                        className="pl-2 text-[rgb(4,35,107)] hover:text-[#f6b51b] text-[14px] font-medium cursor-pointer transition-colors duration-200"
                        onClick={onReadMoreClick}
                    >
                        Read more
                    </span>
                </>
            )}
        </div>
    );
};

export default TooltipWithReadMore;
